import React, { useContext } from 'react';
import TableWithState from '../../components/TableWithState/TableWithState';
import { ETables } from '../../types/enums/ETables';
import useColumnsHeaders from '../../utils/useColumnsHeaders';
import useCellStatusStyleHandler from '../../utils/useCellStatusStyleHandler';
import { NSActivationCodes } from '../../types/interfaces/NSActivationCodes';
import { EStatus } from '../../types/enums/EStatus';
import RowCheckbox from '../Packages/components/RowCheckbox/RowCheckbox';
import { Cell, Column } from 'react-table';
import HeaderCheckbox from '../Packages/components/HeaderCheckbox/HeaderCheckbox';
import { format } from 'date-fns';
import { SessionContext } from '../../contexts/session/SessionContext';
const tableName = ETables.PromoCodes;

const time = (date: any) => {
  try {
    return format(new Date(date), 'yyyy-MM-dd HH:mm');
  } catch (error) {
    return format(new Date(), 'yyyy-MM-dd HH:mm');
  }
};
const PromoCodes = () => {
  const { permissions } = useContext(SessionContext);

  const cellStyleHandler = useCellStatusStyleHandler();

  const dataFormatter = (dataTable: NSActivationCodes.ITableItem[]): any =>
    dataTable.map((code) => ({
      status: code.assigned ? EStatus.Used : EStatus.Valid, // code.status,
      code: code._id,
      assignedTo: code.assigned || '',
      group: code.group,
      reservedBy: code.reservedBy,
      jsxCheckbox: (cell: Cell) => <RowCheckbox tableName={tableName} cell={cell} propNameForId={'code'} />,
      createdAt: time(code.createdAt),
    }));

  const columns = useColumnsHeaders([
    {
      accessorAsHeader: 'jsxCheckbox',
      customHeader: (column: { data: { code: string }[] } & Column) => (
        <HeaderCheckbox tableName={tableName} idList={column.data.map((promocode) => promocode.code)} />
      ),
    },
    { accessorAsHeader: 'status' },
    { accessorAsHeader: 'code' },
    { accessorAsHeader: 'assignedTo' },
    { accessorAsHeader: 'group' },
    { accessorAsHeader: 'reservedBy' },
    { accessorAsHeader: 'createdAt' },
  ]);

  return (
    <TableWithState
      tableName={tableName}
      dataFormatter={dataFormatter}
      columns={columns}
      cellStyleHandler={cellStyleHandler}
      addable={false}
      generateCodes={permissions.promocodes.edit}
      exportable={true}
    />
  );
};

export default PromoCodes;
